<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar [isCondensed]="isCondensed"></app-sidebar>

  <div class="content-page">
    <div class="content">
      <div class="content-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">PayEXAP</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/purchase-orders">Purchase Orders</a>
            </span>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div
                *ngIf="sessionExpired"
                class="alert alert-danger session-text text-center"
                role="alert"
              >
                {{ errorMsg }}
                <span class="relogin" (click)="accountLogout()"
                  >Click here to LogIn</span
                >
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="pane-header mb-3">
                    <h4 class="mt-2">View PO/GRN and Submit Invoices</h4>
                  </div>
                  <div class="search-pane">
                    <div class="row">
                      <div class="col-md-2">
                        <label class="d-inline-flex align-items-center mb-3">
                          <select
                            class="form-select form-select-sm mx-1"
                          
                            [(ngModel)]="filterBy"
                          >
                            <option disabled selected hidden>Select</option>
                            <option value="docNo">PO No.</option>
                            <option value="currCode">PO Currency</option>
                            <option value="location">Location</option>
                          </select>
                        </label>
                      </div>
                      <div class="col-md-4">
                        <div class="input-group flex-nowrap">
                          <ng-container *ngIf="selectedOption">
                            <input
                              type="text"
                              class="form-control highlighted"
                              placeholder="Enter search value"
                              aria-label="search"
                              aria-describedby="addon-wrapping"
                              (keyup)="generalSearch($event)"
                            />
                            <span
                              class="input-group-text highlighted"
                              id="addon-wrapping"
                              ><i class="ri-search-line"></i
                            ></span>
                          </ng-container>
                          <ng-container *ngIf="!selectedOption">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Search..."
                              aria-label="search"
                              aria-describedby="addon-wrapping"
                              (keyup)="generalSearch($event)"
                            />
                            <span class="input-group-text" id="addon-wrapping"
                              ><i class="ri-search-line"></i
                            ></span>
                          </ng-container>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="download-pane float-end d-flex align-items-center gap-3">
                          <i
                            class="ri-refresh-line"
                            title="Refresh"
                            (click)="!loading && refreshPos()"
                            [style.opacity]="loading ? 0.45 : 1"
                            [style.pointer-events]="loading ? 'none' : 'auto'"
                          ></i>
                          <i
                            class="ri-file-download-line"
                            (click)="exportToExcel()"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive">
                    <!-- First load only: nothing to show yet -->
                    <ng-container *ngIf="loading && !pos?.length">
                      <div class="text-center py-5">
                        <app-loader></app-loader>
                      </div>
                    </ng-container>

                    <!-- Empty result -->
                    <div
                      *ngIf="!loading && isEmpty"
                      class="text-center py-5"
                    >
                      <img src="assets/images/empty-state.png" alt="No-data" />
                      <h1 class="card-title my-2">
                        No Purchases Orders Available
                      </h1>
                      <p class="card-text">
                        There is no available data to show yet
                      </p>
                    </div>

                    <!-- Table stays mounted during reloads (sort/paging) so it
                         does not disappear; a spinner overlays it instead. -->
                    <ng-container *ngIf="!isEmpty && pos?.length">
                      <div *ngIf="loading" class="table-loading-overlay">
                        <app-loader></app-loader>
                      </div>
                        <table
                          aria-describedby="purchase-orders"
                          id="demo-foo-pagination"
                          class="table mb-0 table-striped toggle-arrow-tiny tablet breakpoint purchase-orders text-nowrap"
                          data-page-size="5"
                        >
                          <thead>
                            <tr>
                              <th></th>
                              <th
                                scope="col"
                                class="text-center sortable"
                                (click)="onSort('docNo')"
                              >
                                PO No
                                <span class="sort-indicator"
                                  ><i
                                    class="bi"
                                    [ngClass]="sortIconClass('docNo')"
                                  ></i
                                ></span>
                              </th>

                              <th
                                scope="col"
                                class="text-center sortable"
                                (click)="onSort('sesMat')"
                              >
                                PO Type
                                <span class="sort-indicator"
                                  ><i
                                    class="bi"
                                    [ngClass]="sortIconClass('sesMat')"
                                  ></i
                                ></span>
                              </th>

                              <th
                                scope="col"
                                class="text-center sortable"
                                (click)="onSort('barcodePrefix')"
                              >
                                Location
                                <span class="sort-indicator"
                                  ><i
                                    class="bi"
                                    [ngClass]="sortIconClass('barcodePrefix')"
                                  ></i
                                ></span>
                              </th>

                              <th
                                scope="col"
                                class="po-amount sortable"
                                (click)="onSort('docAmt')"
                              >
                                PO Amount
                                <span class="sort-indicator"
                                  ><i
                                    class="bi"
                                    [ngClass]="sortIconClass('docAmt')"
                                  ></i
                                ></span>
                              </th>

                              <th
                                scope="col"
                                class="po-amount sortable"
                                (click)="onSort('openPOAmount')"
                              >
                                Open PO Amount
                                <span class="sort-indicator"
                                  ><i
                                    class="bi"
                                    [ngClass]="sortIconClass('openPOAmount')"
                                  ></i
                                ></span>
                              </th>

                              <th
                                scope="col"
                                class="po-amount sortable"
                                (click)="onSort('invoicedAmount')"
                              >
                                Invoiced Amount
                                <span class="sort-indicator"
                                  ><i
                                    class="bi"
                                    [ngClass]="sortIconClass('invoicedAmount')"
                                  ></i
                                ></span>
                              </th>

                              <th
                                scope="col"
                                class="po-amount sortable"
                                (click)="onSort('inProcessInvoiceAmount')"
                              >
                                In-Process Invoice Amount
                                <span class="sort-indicator"
                                  ><i
                                    class="bi"
                                    [ngClass]="
                                      sortIconClass('inProcessInvoiceAmount')
                                    "
                                  ></i
                                ></span>
                              </th>

                              <th scope="col" class="text-center action-col">
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            <tr *ngFor="let po of pos">
                              <td>
                                <div class="form-check">
                                  <ng-container
                                    *ngIf="
                                      po.sesMat === 'MAT' ||
                                      po.sesMat === 'SERV'
                                    "
                                  >
                                    <input
                                      class="form-check-input"
                                      type="radio"
                                      [(ngModel)]="poSelected"
                                      [value]="po"
                                      (change)="onSelectChanges($event)"
                                    />
                                  </ng-container>
                                </div>
                              </td>
                              <td class="text-center">
                                <!-- <a

                                  routerLink="/purchase-order-detail/{{
                                    po.docNo
                                  }}"
                                  >{{ po.docNo }}</a
                                > -->
                                <a
                                  (click)="viewPoDetails(po)"
                                  href="javascript:void(0)"
                                  >{{ po.docNo }}</a
                                >
                              </td>

                              <td
                                class="text-center"
                                *ngIf="po.sesMat === 'SERV'"
                              >
                                Service
                              </td>
                              <td
                                class="text-center"
                                *ngIf="po.sesMat === 'MAT'"
                              >
                                Material
                              </td>
                              <td class="text-center">{{ po.location }}</td>
                              <td class="po-amount">
                                {{ po.docAmt | inrdisplay }} {{ po.currCode }}
                              </td>

                              <td class="po-amount">
                                {{ po.openPOAmount | inrdisplay }} {{ po.currCode }}
                              </td>
                              <td class="po-amount">
                                {{ po.invoicedAmount | inrdisplay }} {{ po.currCode }}
                              </td>
                              <td class="po-amount">
                                {{ po.inProcessInvoiceAmount | inrdisplay }}
                                {{ po.currCode }}
                              </td>
                              <td class="text-center action-col">
                                <a
                                  *ngIf="
                                    po.sesMat === 'MAT' &&
                                    po.canSubmitInvoice === true &&
                                    (impersonate === 'false' || imp.canSubmitWhileImpersonated())
                                  "
                                  (click)="submitPo(po)"
                                  class="btn-action-link"
                                >
                                  Submit Invoice
                                </a>
                                <a
                                  *ngIf="
                                    po.sesMat === 'MAT' &&
                                    po.canSubmitInvoice === true &&
                                    impersonate === 'true'
                                  "
                                  routerLink="/proof-of-delivery/{{ po._id }}"
                                  class="btn-action-link extended"
                                >
                                  View GRN
                                </a>
                                <ng-container
                                  *ngIf="
                                    po.sesMat === 'MAT' &&
                                    po.canSubmitInvoice === false
                                  "
                                  class="btn-action-link btn-extended"
                                >
                                  <div class="grn tooltip-popup">
                                    <i class="ri-information-fill"></i>
                                    <span class="tooltiptext"
                                      >Invoicing Party is different.
                                      <a routerLink="/view-grn/{{ po._id }}">
                                        View GRN</a
                                      ></span
                                    >
                                  </div>
                                </ng-container>
                                <ng-container
                                  *ngIf="
                                    po.sesMat === 'SERV' &&
                                    po.canSubmitInvoice === false
                                  "
                                  class="btn-action-link btn-extended"
                                >
                                  <div class="grn tooltip-popup">
                                    <i class="ri-information-fill"></i>
                                    <span class="tooltiptext"
                                      >Invoicing Party is different.
                                    </span>
                                  </div>
                                </ng-container>
                                <a
                                  *ngIf="
                                    po.sesMat === 'SERV' &&
                                    po.canSubmitInvoice === true &&
                                    (impersonate === 'false' || imp.canSubmitWhileImpersonated())
                                  "
                                  (click)="submitServiceInvoice(po)"
                                  href="javascript:void(0)"
                                  class="btn-action-link"
                                >
                                  Submit Invoice
                                </a>
                                <a
                                  *ngIf="
                                    po.sesMat === 'SERV' &&
                                    po.canSubmitInvoice === true &&
                                    impersonate === 'true'
                                  "
                                  routerLink="/po-line-items/{{ po.docNo }}"
                                  class="btn-action-link"
                                >
                                  View Line Items
                                </a>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="9">
                                <button
                                  *ngIf="impersonate === 'false' || imp.canSubmitWhileImpersonated()"
                                  [disabled]="!isSelected"
                                  [title]="
                                    isSelected
                                      ? ''
                                      : 'Select a PO using the radio button first'
                                  "
                                  class="btn btn-credit-note float-start"
                                  (click)="sendPo()"
                                >
                                  Submit Credit/Debit Note{{
                                    poSelected
                                      ? " for PO " + poSelected.docNo
                                      : " for Selected PO"
                                  }}
                                </button>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </ng-container>

                    <div class="table-footer py-3">
                      <div class="row">
                        <div class="col-sm-5">
                          <label class="d-inline-flex align-items-center mb-3">
                            Show
                            <select
                              id="demo-show-entries"
                              class="form-select form-select-sm mx-1"
                              [(ngModel)]="pageSize"
                              (ngModelChange)="refreshPos()"
                            >
                              <option [ngValue]="10">10</option>
                              <option [ngValue]="25">25</option>
                              <option [ngValue]="50">50</option>
                              <option [ngValue]="100">100</option>
                            </select>
                            entries
                          </label>
                          <div
                            *ngIf="!loading && !isEmpty && collectionSize"
                            class="text-muted small"
                          >
                            Showing {{ showingStart }}–{{ showingEnd }} of
                            {{ collectionSize }} entries
                          </div>
                        </div>
                        <div class="col-sm-7">
                          <div class="text-end">
                            <ngb-pagination
                              class="justify-content: flex-end !important;"
                              [collectionSize]="collectionSize"
                              [(page)]="page"
                              [pageSize]="pageSize"
                              [maxSize]="4"
                              [rotate]="true"
                              [ellipses]="false"
                              [boundaryLinks]="true"
                              (pageChange)="refreshPos()"
                            >
                            </ngb-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
